module.exports = __webpack_public_path__ + "img/apphi@3x.cde467a8.png";